import { helper as buildHelper } from '@ember/component/helper';

export const I18N_PREFIX = 'helpers.label-for-region';

export function labelForRegion([region], { provider }) {
  return `${I18N_PREFIX}.${provider}.${region}`;
}

export default buildHelper(labelForRegion);
